module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card is-centered"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": '/static/' + _vm.cardInfo.coverImage,
      "alt": "Cover Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image",
    staticStyle: {
      "height": "40px",
      "width": "40px"
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/' + _vm.cardInfo.profileImage,
      "alt": "Profile picture"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.cardInfo.title))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(_vm._s(_vm.cardInfo.subtitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      " + _vm._s(_vm.cardInfo.description) + "\n      "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.cardInfo.date))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a9954cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card.vue
// module id = 268
// module chunks = 2